<!-- 销售退补价操作 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <salesbookkeepingTemplate ref="salesbookkeepingTemplate"></salesbookkeepingTemplate>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                  :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                           <el-form class="baseForm" id="mainInfo" label-width="120px" :model="sendDataInfo"
                              ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField"
                                    v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <!-- 记账单号 -->
                                    <el-tooltip v-if="formOneValue.fieldType == 'extract'" class="item"
                                       :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                       effect="dark" :content="sendDataInfo[formOneValue.entityField]"
                                       placement="bottom-start">
                                       <el-input v-if="formOneValue.fieldType == 'extract'" clearable
                                          v-model="sendDataInfo[formOneValue.entityField]"
                                          :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                          @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                          <el-button
                                             @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                             slot="append" icon="el-icon-search"
                                             :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                       :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                       effect="dark" :content="sendDataInfo[formOneValue.entityField]"
                                       placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]"
                                          :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                             slot="append" icon="el-icon-search"
                                             :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-select :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                       size="mini" v-else-if="formOneValue.fieldType == 'formatter'"
                                       v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                          :key="matItem.key" :label="matItem.key" :value="String(matItem.value)">
                                       </el-option>
                                    </el-select>
                                    <!-- 申请日期 -->
                                    <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false"
                                       @keyup.enter.native="nextFocus(formOneKey)"
                                       :isdisabled="formOneValue.isChange == 0"
                                       v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                    <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]"
                                       @keyup.enter.native="nextFocus(formOneKey)"
                                       :disabled="formOneValue.isChange == 0"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField"
                                    v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.entityField == 'isWms'">{{ sendDataInfo.isWms
                                       == 0 ? '否' : '是' }}</span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{
                                             $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                          }}
                                       </span>
                                    </span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <el-form :inline="true" size="mini">
                              <!-- 操作 -->
                              <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                 <el-button type="primary" size="mini" @click="deleteDetails()">删除明细</el-button>
                              </div>
                              <el-table size="mini" :data="sendDataInfo.rrapplydetailAdds" ref="mxTableRef"
                                 :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                 @selection-change="handleSelectionChange" :height="mxHeight" border
                                 style="width: 100%">
                                 <el-table-column width="90" label="选择" v-if="dataActionBox.actionType != 2">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border
                                          size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField"
                                    show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                    v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey"
                                    v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <!-- 显示通用名称 -->
                                       <!-- 有效期 -->
                                       <span v-if="formOneValue.fieldType == 'date'">
                                          <span
                                             v-if="sendDataInfo.rrapplydetailAdds[scope.$index][formOneValue.entityField]">
                                             {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                          </span>
                                       </span>
                                       <!-- 退补数量 -->
                                       <el-input
                                          v-else-if="formOneValue.entityField == 'refundNum' && dataActionBox.actionType != 2"
                                          :ref="formOneValue.entityField"
                                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                          @input="computerPrice(5, scope.$index)" type="number"
                                          @change="checkNumber(scope.$index)"
                                          v-model="sendDataInfo.rrapplydetailAdds[scope.$index][formOneValue.entityField]"
                                          :maxlength="$store.state.inputLength"></el-input>
                                       <!-- 退补含税价 -->
                                       <el-input
                                          v-else-if="formOneValue.entityField == 'rradPsprice' && dataActionBox.actionType != 2"
                                          :ref="formOneValue.entityField"
                                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                          @input="computerPrice(2, scope.$index)" type="number"
                                          v-model.trim="sendDataInfo.rrapplydetailAdds[scope.$index][formOneValue.entityField]"
                                          :maxlength="$store.state.inputLength"></el-input>
                                       <!-- 退补金额 -->
                                       <el-input
                                          v-else-if="formOneValue.entityField == 'rradPsmoney' && dataActionBox.actionType != 2"
                                          :ref="formOneValue.entityField"
                                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                          @input="computerPrice(4, scope.$index)" type="number"
                                          v-model.trim="sendDataInfo.rrapplydetailAdds[scope.$index][formOneValue.entityField]"
                                          :maxlength="$store.state.inputLength"></el-input>
                                       <!-- 新含税价 -->
                                       <el-input
                                          v-else-if="formOneValue.entityField == 'newPrice' && dataActionBox.actionType != 2"
                                          :ref="formOneValue.entityField"
                                          @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                          @input="computerPrice(5, scope.$index)" type="number"
                                          v-model.trim="sendDataInfo.rrapplydetailAdds[scope.$index][formOneValue.entityField]"
                                          :maxlength="$store.state.inputLength"></el-input>
                                       <span v-else-if="formOneValue.isRift == 1">
                                          <a
                                             @click="toDetail(sendDataInfo.rrapplydetailAdds[scope.$index][formOneValue.riftField])">{{
                                                sendDataInfo.rrapplydetailAdds[scope.$index][formOneValue.entityField]
                                             }}</a>
                                       </span>
                                       <span v-else>
                                          {{
                                             sendDataInfo.rrapplydetailAdds[scope.$index][formOneValue.entityField]
                                          }}
                                       </span>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>

            <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo"
               @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
         </div>
      </div>
      <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <ExtractionScheme ref="ExtractionScheme" :wobkemId="sendDataInfo.wobkemId" :ppId="ppId" :id="exId"
            @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
         <!-- 原：p-sReturnExtractionScheme :extractData="extractData1"  -->
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
import salesbookkeepingTemplate from '@/components/salesbookkeepingTemplate.vue'
export default {
   name: "salesReimbursemenAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      ExtractionScheme,
      SearchScheme,
      salesbookkeepingTemplate
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            settleMethod: "",
            payMethod: "",
            credit: "",
            dismode: "",
            rrapplydetailAdds: [],
            coId: "",
            // "coName": '',
            rrsiAccperiod: "",
            rrsiDismode: "",
            rrsiPaymode: "",
            rrsiReserves1: "",
            rrsiReserves2: "",
            rrsiReserves3: "",
            rrsiReserves4: "",
            rrsiReserves5: "",
            rrsiReserves6: "",
            rrsiSetmode: "",
            settleMethod: "",
            payMethod: "",
            wobkemId: "",
            woamState: "",
            rramRemark: "",
            rramOpposales: "",
            rramSapdeptName: "",
            rramRapdate: "",
            rramReserves1: "",
            rramReserves2: "",
            rramReserves3: "",
            rramReserves4: "",
            rramReserves5: "",
            rramReserves6: "",
            rramRetcus: "",
            rramSalesman: "",
            rramSapdept: "",
            rramSalesmanName: "",
            totalCount: "",
            totalMoney: "",
            totalNumber: "",
         },
         showTabs: "",
         formDataList: [],
         selectedDetails: [],
         selectedDataIndex: 0,
         selectGoodsInfo: "",
         showTabs: "",
         formDataList: [],
         dictionariesData: {},
         userOneList: [],
         goodsList: [],
         editDateilsIndex: "",
         exId: "",
         seId: "",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogExtract: false,
         newFormDataList: [],
         seType: "",
         smId: "",
         ppId: "",
         mxHeight: 0,
         dictionariesDatas: [], //配送方式
         mxForm: [],
         tabForm: [],
         footForm: [],
         sField: "", // 赋值字段
         fField: "", //焦点字段
         nosField: "", // 不可赋值字段
         inputel: "", //所有input对象
         seTitle: "", //检索
         DialogVisible: false,
         seId: 0,
         seType: "",
         seIndex: 0,
         seWidth: "",
         parentSearchData: {},
         selectedRow: [], // 当前已选择行
         selectedDetailsIndex: 0,
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.rrapplydetailAdds": {
         handler: function (newValue, oldValue) {

            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
            newValue.forEach((item, keys) => {
               let a = item.refundNum
               this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                  3,
                  NP.plus(this.sendDataInfo.totalMoney, parseFloat(item.rradPsmoney))
               );
               this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
                  1,
                  NP.plus(this.sendDataInfo.totalNumber, parseFloat(item.refundNum))
               );
            });
            if (isNaN(this.sendDataInfo.totalMoney)) {
               this.sendDataInfo.totalMoney = 0;
            }
            this.sendDataInfo.totalCount = this.sendDataInfo.rrapplydetailAdds.length;
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      tabHeight(val) {
         this.mxHeight = val
      },
      //删除明细
      deleteDetails() {
         if (this.sendDataInfo.rrapplydetailAdds.length < 1) {
            this.$message({
               message: '请先添加明细',
               type: 'error'
            });
            return false
         }
         this.sendDataInfo.rrapplydetailAdds.splice(this.selectedDetailsIndex, 1)
         this.$nextTick(() => {
            if (this.sendDataInfo.rrapplydetailAdds.length > 1) {
               this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
               this.tableNextFocus('refundNum', this.selectedDetailsIndex)
            } else {
               this.selectedDetailsIndex = 0
            }
            let refsElTable = this.$refs.mxTableRef
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(this.sendDataInfo.rrapplydetailAdds[this.selectedDetailsIndex]);
         })
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         if (el) this.inputel = el.getElementsByTagName("input");
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "") {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 检索Id, 索引(表格中), 标识
      //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
      openSearch(sId, index, type, sField, fField, nosField) {
         this.DialogVisible = true;
         removeEventListener("keyup", this.keyUp);
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.fField = fField;
         this.nosField = nosField;
         this.parentSearchData[type] = this.sendDataInfo[type];
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
            this.paramValue(val);
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item];
         });
         this.$nextTick(() => {
            this.nextFocus(this.seIndex);
         });
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         if (field == "") return;
         if (field == "keydown") {
            if (index == this.sendDataInfo.rrapplydetailAdds.length - 1) return;
            if (this.sendDataInfo.rrapplydetailAdds[index + 1] != undefined) {
               this.$refs["rradPsprice"][index + 1].focus(); //跳退货数量
               this.selectedDetailsIndex = index + 1;
               this.$nextTick(() => {
                  if (this.$refs.mxTableRef) {
                     let refsElTable = this.$refs.mxTableRef
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.rrapplydetailAdds[this.selectedDetailsIndex]
                     );
                  }
               });
               return;
            }
         }
         this.$refs[field] && this.$refs[field][index].focus();
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= this.inputel.length - 1) {
            if (this.sendDataInfo.rrapplydetailAdds.length > 0) {
               this.tableNextFocus("rradPsprice", this.selectedDetailsIndex);
               this.$nextTick(() => {
                  if (this.$refs.mxTableRef) {
                     let refsElTable = this.$refs.mxTableRef;
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.rrapplydetailAdds[this.selectedDetailsIndex]
                     );
                  }
               });
            }
            return;
         }
         var aindex = index + 1;
         if (this.inputel[aindex].value != "" || this.inputel[aindex].disabled) {
            this.nextFocus(aindex);
            return;
         }

         this.inputel[aindex].focus();
      },
      // 监听键盘事件
      keyUp(e) {
         if (e.key == "F1") {
            // 新增明细
            e.preventDefault();
            return;
         } else if (e.key == "F2") {
            e.preventDefault();
            this.deleteDetails();
         } else if (e.keyCode == 40) {
            // 下键
            // 表格为空，不执行下方
            if (this.sendDataInfo.rrapplydetailAdds.length == 0) return;
            let refsElTable = this.$refs.mxTableRef;
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) {
                  // 如果当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0;
               } else if (
                  this.selectedDetailsIndex ==
                  this.sendDataInfo.rrapplydetailAdds.length - 1
               ) {
                  // 如果选中的是最后一行了，那么下一行选中的是第一行
                  this.selectedDetailsIndex = 0;
               } else {
                  // 正常递增
                  this.selectedDetailsIndex++;
               }
               if (!refsElTable) return;
               let findRow = this.selectedRow.find(
                  (c) => c.rowIndex == this.selectedDetailsIndex
               ); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.rrapplydetailAdds[this.selectedDetailsIndex],
                     false
                  );
                  return;
               }
               // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(
                  this.sendDataInfo.rrapplydetailAdds[this.selectedDetailsIndex]
               ); // 把现在当前行勾选
            });
         } else if (e.keyCode == 38) {
            // 上键
            if (this.sendDataInfo.rrapplydetailAdds.length == 0) return;
            let refsElTable = this.$refs.mxTableRef;
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) {
                  // 当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0;
               } else if (this.selectedDetailsIndex == 0) {
                  // 如果选中的是第一行了，那么下一行选中的是最后一行
                  this.selectedDetailsIndex =
                     this.sendDataInfo.rrapplydetailAdds.length - 1;
               } else {
                  // 正常递减
                  this.selectedDetailsIndex--;
               }
               if (!refsElTable) return;
               let findRow = this.selectedRow.find(
                  (c) => c.rowIndex == this.selectedDetailsIndex
               ); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.rrapplydetailAdds[this.selectedDetailsIndex],
                     false
                  );
                  return;
               }
               // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(
                  this.sendDataInfo.rrapplydetailAdds[this.selectedDetailsIndex]
               ); // 把现在当前行勾选
            });
         }
      },
      closeChild() {
         addEventListener("keyup", this.keyUp); //创建监听键盘事件
      },
      // 表格方法
      rowClassName({ row, rowIndex }) {
         let rowName = "",
            findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
         if (findRow) {
            rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
         }
         return rowName; //也可以再加上其他类名 如果有需求的话
      },

      // 选中行底色逻辑
      rowStyle({ row, rowIndex }) {
         Object.defineProperty(row, "rowIndex", {
            // 给每行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
         });
         let rowBackground = {}
         if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
         return rowBackground
      },

      // 明细表格点击选中
      clickEvent(row, column, event, params) {
         let refsElTable = this.$refs.mxTableRef; // 获取表格对象
         let findRow = {};
         this.selectedDetailsIndex = row.rowIndex;
         findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
         //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
         if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(row, false);
            return;
         }
         // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
         refsElTable.clearSelection();
         refsElTable.toggleRowSelection(row);
      },

      // 保存已选择行
      handleSelectionChange(rows) {
         this.selectedRow = rows; // 保存已选择行
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2)
            this.$parent.$parent.toDetail(orderId);
         else this.$parent.$parent.$parent.toDetail(orderId);
      },
      async getDataByChen(val) {
         if (val != "" || val != undefined) {
            this.sendDataInfo.rrapplydetailAdds = []
            for (let key in val) {
               if (key == "arrlistbychen") {
                  for (const key1 in val.arrlistbychen) {
                     this.$set(this.sendDataInfo.rrapplydetailAdds, key1, val.arrlistbychen[key1])
                     for (const key2 in val.arrlistbychen[key1]) {
                        this.$set(this.sendDataInfo.rrapplydetailAdds[key1], key2, val.arrlistbychen[key1][key2])
                     }
                  }
               } else {
                  this.$set(this.sendDataInfo, key, val[key])
                  this.sendDataInfo.isWms = this.sendDataInfo.isWms == 0 ? "否" : "是";
               }
            }
            this.sendDataInfo.rrapplydetailAdds.forEach((item, i) => {
               this.sendDataInfo.rrapplydetailAdds[i].rradPrice = item.rradPrice||0;
               this.sendDataInfo.rrapplydetailAdds[i].rradMoney = item.rradMoney||0;
               this.$set(this.sendDataInfo.rrapplydetailAdds[i], "rradPsprice", 0);
               this.$set(this.sendDataInfo.rrapplydetailAdds[i], "rradPsmoney", 0);
               this.$set(this.sendDataInfo.rrapplydetailAdds[i], "woadWcost", 0);
               this.$set(this.sendDataInfo.rrapplydetailAdds[i], "costMoney", 0);
               this.$set(this.sendDataInfo.rrapplydetailAdds[i], "costPrice", 0);
               this.$set(this.sendDataInfo.rrapplydetailAdds[i], "costAmount", 0);
               this.$set(this.sendDataInfo.rrapplydetailAdds[i], "gross", 0); //毛利
               this.$set(this.sendDataInfo.rrapplydetailAdds[i], "newPrice", 0); //新含税价
               this.$set(this.sendDataInfo.rrapplydetailAdds[i], "refundNum", item.refundNum || 0);
               // this.computerPrice(5, i)
            });
            this.sendDataInfo.totalcount =
               this.sendDataInfo.rrapplydetailAdds.length;
            this.DialogExtract = false;
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
            this.$nextTick(() => {
               this.selectedDetailsIndex = 0;
               this.tableNextFocus("rradPsprice", 0);
               let refsElTable = this.$refs.mxTableRef;
               refsElTable && refsElTable.clearSelection();
               refsElTable && refsElTable.toggleRowSelection(
                  this.sendDataInfo.rrapplydetailAdds[this.selectedDetailsIndex]
               );
               this.nextFocus(this.seIndex);
            });
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      // 提取方案Id, 索引(表格中), 标识
      openExComponents(eId, index, type) {
         this.DialogExtract = true;
         removeEventListener("keyup", this.keyUp);
         this.exId = eId;
         this.seIndex = index;
         this.seType = type;
         this.ppId = "wobkemId";
         this.extractData1 = {
            id: this.exId,
            ppId: this.ppId,
            idType: "ormId",
            wobkemId: this.sendDataInfo.wobkemId
         };
      },
      checkNumber(index) {
         var info = this.sendDataInfo.rrapplydetailAdds[index];
         if (info.woadPnumber > 0) {
            if (info.refundNum > info.woadPnumber) {
               this.sendDataInfo.rrapplydetailAdds[index].refundNum = info.woadPnumber;
               this.$message({
                  message: "退补数量不能大于原单数量",
                  type: "warning",
               });
            } else if (info.refundNum <= 0) {
               this.sendDataInfo.rrapplydetailAdds[index].refundNum = info.woadPnumber;
               this.$message({
                  message: "退补数量不能小于或等于0",
                  type: "warning",
               });
            }
         } else {
            if (info.refundNum < info.woadPnumber) {
               this.sendDataInfo.rrapplydetailAdds[index].refundNum = info.woadPnumber;
               this.$message({
                  message: "退补数量不能小于原单数量",
                  type: "warning",
               });
            } else if (info.refundNum >= 0) {
               this.sendDataInfo.rrapplydetailAdds[index].refundNum = info.woadPnumber;
               this.$message({
                  message: "退补数量不能大于或等于0",
                  type: "warning",
               });
            }
         }
         this.computerPrice(5, index)
      },
      // 计算价格
      computerPrice(cate, index) {
         var info = this.sendDataInfo.rrapplydetailAdds[index];
         // if(info.refundNum > info.refundNum){
         //       this.sendDataInfo.rrapplydetailAdds[index].refundNum = info.refundNum;
         //       this.$message({
         //           message: "退补数量不能大于出库数量",
         //           type: "warning",
         //       });
         //   }
         switch (cate) {
            case 1: // 通过单价计算全部
               // 计算含税价格 单价+单价*税率/100
               var thisPrice = this.$common.getDecimalInfo(
                  2,
                  NP.plus(
                     info.rradPrice,
                     NP.divide(NP.times(info.rradPrice, info.outRate), 100)
                  )
               );
               this.sendDataInfo.rrapplydetailAdds[index].rradPsprice = thisPrice;

               // 计算金额 单价*数量
               this.sendDataInfo.rrapplydetailAdds[index].rradMoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(info.rradPrice, info.refundNum)
                  );

               // 计算含税金额 含税价格*数量
               this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(thisPrice, info.refundNum)
                  );
               break;
            case 2: // 通过含税价格计算全部(gross毛利)
               // 计算退补含税金额 退补含税价格*数量
               this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.rradPsprice, info.refundNum));
               // 计算退补金额 退补含税金额/(税率/100+1)
               var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney, NP.plus(NP.divide(info.outRate, 100), 1)))
               // var midmoney = NP.divide(this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney, NP.plus(NP.divide(info.outRate, 100), 1)).toFixed(10)
               this.sendDataInfo.rrapplydetailAdds[index].rradMoney = this.$common.getDecimalInfo(3, midmoney);
               // 计算退补单价 退补金额/数量
               this.sendDataInfo.rrapplydetailAdds[index].rradPrice = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.refundNum));

               // 计算毛利
               this.sendDataInfo.rrapplydetailAdds[index].gross = this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney;
               // 新含税价 退补价+原含税价
               this.sendDataInfo.rrapplydetailAdds[index].newPrice = NP.plus(info.psprice, info.rradPsprice)
               break;
            case 3: // 通过总金额计算全部
               // 计算单价  总金额 / 数量
               var thisPrice = this.$common.getDecimalInfo(
                  2,
                  NP.divide(info.rradMoney, info.refundNum)
               );
               this.sendDataInfo.rrapplydetailAdds[index].rradPrice = thisPrice;

               // 计算含税价格 单价+单价*税率/100
               var thisPriceTwo = this.$common.getDecimalInfo(
                  3,
                  NP.plus(
                     thisPrice,
                     NP.divide(NP.times(thisPrice, info.outRate), 100)
                  )
               );
               this.sendDataInfo.rrapplydetailAdds[index].rradPsprice = thisPriceTwo;

               // 计算含税金额 含税价格*数量
               this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(thisPriceTwo, info.refundNum)
                  );
               break;

            case 4: // 通过退补含税金额计算全部
               if (info.rradPsmoney > info.psmoney) {
                  this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney = info.psmoney;
               }
               // 计算退补含税价格  退补含税金额 / 退补数量
               this.sendDataInfo.rrapplydetailAdds[index].rradPsprice = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.rradPsmoney, info.refundNum));
               // 计算退补总金额 退补含税金额/(税率/100+1)
               var midmoney = this.$common.getDecimalInfo(3, NP.divide(info.rradPsmoney, NP.plus(NP.divide(info.outRate, 100), 1)))
               // var midmoney = NP.divide(info.rradPsmoney, NP.plus(NP.divide(info.outRate, 100), 1)).toFixed(10)
               this.sendDataInfo.rrapplydetailAdds[index].rradMoney = this.$common.getDecimalInfo(3, midmoney);
               // 计算退补单价 退补金额/数量
               this.sendDataInfo.rrapplydetailAdds[index].rradPrice = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.refundNum));

               // 计算毛利
               this.sendDataInfo.rrapplydetailAdds[index].gross = this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney;
               // 新含税价 退补价+原含税价
               this.sendDataInfo.rrapplydetailAdds[index].newPrice = NP.plus(info.psprice, this.sendDataInfo.rrapplydetailAdds[index].rradPsprice)
               break;
            case 5: // 
               // 退补价：新含税价 -原含税价
               this.sendDataInfo.rrapplydetailAdds[index].rradPsprice = NP.minus(info.newPrice, info.psprice)
               this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.rradPsprice, info.refundNum));
               this.sendDataInfo.rrapplydetailAdds[index].saleQumoney = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.saleQuprice||0, info.refundNum));
               // 计算退补金额 退补含税金额/(税率/100+1)
               var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney, NP.plus(NP.divide(info.outRate, 100), 1)))
               // var midmoney = NP.divide(this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney, NP.plus(NP.divide(info.outRate, 100), 1)).toFixed(10)
               this.sendDataInfo.rrapplydetailAdds[index].rradMoney = this.$common.getDecimalInfo(3, midmoney);
               // 计算退补单价 退补金额/数量
               this.sendDataInfo.rrapplydetailAdds[index].rradPrice = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.refundNum));
               // 计算毛利
               this.sendDataInfo.rrapplydetailAdds[index].gross = this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney;
               break;
            default:
               // 通过数量计算
               // 计算退补含税金额 退补含税价格*数量
               var midmoney = info.refundNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.rradPsprice, info.refundNum));
               // var midmoney = info.refundNum === 0 ? 0 : NP.times(info.rradPsprice, info.refundNum).toFixed(10);
               this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney = this.$common.getDecimalInfo(3, midmoney);
               // 计算退补金额 退补含税金额/(税率/100+1)
               this.sendDataInfo.rrapplydetailAdds[index].rradMoney = this.$common.getDecimalInfo(3, NP.divide(midmoney, NP.plus(NP.divide(info.outRate, 100), 1)));
               // 原含税金额 原含税价格*数量
               this.sendDataInfo.rrapplydetailAdds[index].psmoney = this.$common.getDecimalInfo(3, NP.times(info.psprice, info.refundNum));
               // // 含税成本金额 含税成本价格*数量
               // this.sendDataInfo.rrapplydetailAdds[index].costMoney = this.$common.getDecimalInfo(3, NP.times(info.woadWcost, info.refundNum));
               // // 成本金额 成本价格*数量
               // this.sendDataInfo.rrapplydetailAdds[index].costAmount = this.$common.getDecimalInfo(3, NP.times(info.costPrice, info.refundNum));
               // 计算毛利  costMoney成本金额
               //销售金额  = 数量*(退补含税价+原含税价)
               var myPsMoney = NP.times(NP.plus(info.rradPsprice ? info.rradPsprice : 0, info.psprice), info.refundNum);
               this.sendDataInfo.rrapplydetailAdds[index].gross = this.sendDataInfo.rrapplydetailAdds[index].rradPsmoney;
               break;
         }
         //   this.sendDataInfo.totalmoney = 0;
         //   this.sendDataInfo.totalnumber = 0;
         //   this.sendDataInfo.totalcount = 0;
         //   this.sendDataInfo.rrapplydetailAdds.forEach((item, keys) => {
         //     this.sendDataInfo.totalmoney = this.$common.getDecimalInfo(
         //       3,
         //       NP.plus(this.sendDataInfo.totalmoney, item.rradPsmoney)
         //     );
         //     this.sendDataInfo.totalnumber = this.$common.getDecimalInfo(
         //       1,
         //       NP.plus(this.sendDataInfo.totalnumber, item.refundNum)
         //     );
         //   });
         //   this.sendDataInfo.totalcount = this.sendDataInfo.rrapplydetailAdds.length;
      },
      initActionBox(sendDataInfo) {
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$common.delOrderInfo(this.sendDataInfo.wobkemId)
               this.init();
               this.$emit("drawerCancel");
               this.$refs.sendDataInfo.resetFields();
            })
            .catch(() => {
               // this.$message({
               //     type: 'info',
               //     message: '取消关闭'
               // });
            });
      },
      init() {
         for (let key in this.sendDataInfo) {
            if (key == "rrapplydetailAdds") {
               for (let sonOne in this.sendDataInfo[key]) {
                  this.sendDataInfo[key][sonOne] = "";
               }
            } else {
               if (this.sendDataInfo[key] === "" || this.sendDataInfo[key] == undefined) {
                  this.sendDataInfo[key] = "";
               }
            }
         }
         this.sendDataInfo.rrapplydetailAdds = [];
         this.sendDataInfo.totalmoney = 0;
         this.sendDataInfo.totalnumber = 0;
         this.sendDataInfo.totalcount = 0;
      },

      // 提取数据
      async extractData(data = "") {
         if (data.length >= 1) {
            var sendData = [];
            data.forEach((items) => {
               sendData.push(items.wobkedId);
            });
            let responseData = await this.$http.extractSalesBookkeeping({
               ids: sendData,
            });
            if (responseData.status == 200) {
               this.sendDataInfo = responseData.result;
               this.sendDataInfo.rramRapdate = this.$moment().valueOf();
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         }
      },
      async isShowData(name, value) {
         this.sendDataInfo[name] = value;
      },
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField();
         this.init();
         if (this.dataActionBox.actionType == 0) {
            this.sendDataInfo.wobkemId = "";
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.sendDataInfo.rramRapdate = this.$moment().valueOf();
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            for (const key in oldData) {
               this.$set(this.sendDataInfo, key, oldData[key])
            }
            this.sendDataInfo.totalmoney = oldData.totalMoney;
            this.sendDataInfo.totalcount = oldData.totalCount;
            this.sendDataInfo.totalnumber = oldData.totalNumber;
            this.$nextTick(() => {
               this.selectedDetailsIndex = 0;
               let refsElTable = this.$refs.mxTableRef;
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(
                  this.sendDataInfo.rrapplydetailAdds[this.selectedDetailsIndex]
               );
            });
            this.sendDataInfo.isWms = oldData.isWms == 0 ? "否" : "是";
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
               this.sendDataInfo.totalmoney = dataInfo.totalMoney;
               this.sendDataInfo.totalcount = dataInfo.totalCount;
               this.sendDataInfo.totalnumber = dataInfo.totalNumber;
               this.sendDataInfo.isWms = oldData.isWms == 0 ? "否" : "是";
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.$refs['tree'].init(this.sendDataInfo.rramId)
                  this.mxHeight = this.$common.getHeight()
               }
               this.initFocus()
            }, 16.7)
         });
      },
      async sendDataAction(sendDataInfo) {
         this.$refs.sendDataInfo.validate((valid) => {
            if (valid) {
               if (
                  this.sendDataInfo.rrapplydetailAdds.some(
                     (val) => val.rradPsprice == 0 || val.rradPsprice == "" || val.rradPsmoney == 0 || val.rradPsmoney == ''
                  )
               ) {
                  this.$message({
                     type: "error",
                     message: "请填写合理的退补含税价",
                  });
                  return;
               }
               this.sub();
            } else {
               console.log("error submit!!");
               return false;
            }
         });
         if (this.sendDataInfo.wobkemId == "") {
            this.$message({
               message: "请选择出库记账单",
               type: "error",
            });
            return false;
         }
      },
      async sub() {
         this.sendDataInfo.isWms = this.sendDataInfo.isWms == "是" ? 1 : 0;
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.addSalesReimbursement(sendData);
         } else {
            var responseData = await this.$http.setSalesReimbursement(sendData);
         }
         if (responseData.status == 200) {
            this.init();
            this.$refs.sendDataInfo.resetFields();
            this.$emit("drawerCancel");
            this.$message({
               message: "操作成功",
               type: "success",
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //获取配送方式
      async distributionModes() {
         let responseData = await this.$http.getCateDictionariesData({
            ids: [37],
         });
         if (responseData.status == 200) {
            this.dictionariesDatas = responseData.result;
            // console.log('配送方式',this.dictionariesDatas);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "rrapplydetailAdds" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      // this.distributionModes()	//配送
      this.$nextTick(() => {
         this.openBox();
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      document.onkeydown = function () {
         if (window.event.keyCode === 38 || window.event.keyCode === 40) {
            window.event.returnValue = false;
         }
      }
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
   },
   beforeDestroy() {
      //生命周期 - 更新之前
      removeEventListener("keyup", this.keyUp);
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.el-table .el-form-item {
   margin-bottom: 0;
}
</style>